import styled from 'styled-components';

export const LoaderStyle = styled.div<{ size: string }>`
  display: inline-block;
  position: relative;
  width: 64px;
  height: 16px;

  div {
    position: absolute;
    top: 0;
    width: ${(props) => props.size};
    height: ${(props) => props.size};
    border-radius: 50%;
    background: ${({ theme }) => theme.palette.background.paper};
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }

  div:nth-child(1) {
    left: 6px;
    animation: lds-animate-scale 0.6s infinite;
  }

  div:nth-child(2) {
    left: 6px;
    animation: lds-animate-translate 0.6s infinite;
  }

  div:nth-child(3) {
    left: 26px;
    animation: lds-animate-translate 0.6s infinite;
  }

  div:nth-child(4) {
    left: 45px;
    animation: lds-animate-scale-reverse 0.6s infinite;
  }

  @keyframes lds-animate-scale {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }

  @keyframes lds-animate-scale-reverse {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }

  @keyframes lds-animate-translate {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(19px, 0);
    }
  }
`;
